import { render, staticRenderFns } from "./MuwOrderList.vue?vue&type=template&id=5b3a642b&scoped=true&"
import script from "./MuwOrderList.vue?vue&type=script&lang=js&"
export * from "./MuwOrderList.vue?vue&type=script&lang=js&"
import style0 from "./MuwOrderList.vue?vue&type=style&index=0&id=5b3a642b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a642b",
  null
  
)

export default component.exports